import useProfiler from "hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_index_remove_subtitle_ddot",
  stages: {
    main: 1, // index page,
    direct: 2,
    meta: 3,
    us: 4
  },
  goals: {
    searchClick: 1
  },
  defaultStage: 1,
  mainStage: 1
});

const useTrackStages = () => {
  const { isDirect, isAmerican } = useProfiler();

  utils.stages.main();
  isDirect() ? utils.stages.direct() : utils.stages.meta();
  isAmerican() && utils.stages.main();
};

let didClickSearch = false;
const trackClickSearch = () => {
  if (!didClickSearch) {
    utils.goals.searchClick();
    didClickSearch = true;
  }
};

export default { ...utils, useTrackStages, trackClickSearch };
